module.exports = __webpack_public_path__ + "static/img/Screenshot_1.a3bb2fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Screenshot_1.png
// module id = Zcan
// module chunks = 1